import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  consumePostLoginRedirectForKey,
  isSafeInternalPath,
} from 'utils/postLoginRedirect';

type PostLoginOrDefaultRedirectProps = {
  defaultPath: string;
};

/**
 * After auth, `/` resolves here: pending sessionStorage redirect or default app home.
 */
export default function PostLoginOrDefaultRedirect({
  defaultPath,
}: PostLoginOrDefaultRedirectProps) {
  const { key } = useLocation();
  const raw = consumePostLoginRedirectForKey(key) ?? defaultPath;
  const safeTarget = isSafeInternalPath(raw) ? raw : '/';
  return <Navigate to={safeTarget} replace />;
}
